import { FC } from 'react'

import TrainingPersonFormFields from './training-person-form-fields'

import { ITrainingPersonFormProps } from './training-person-form-types'

const TrainingPersonForm: FC<ITrainingPersonFormProps> = props => {
  const { handleSubmit, formName, submitting } = props

  return (
    <form onSubmit={handleSubmit} id={formName}>
      <TrainingPersonFormFields disabled={submitting} />
    </form>
  )
}

export default TrainingPersonForm
